export const last = arr => {
  const arrLength = arr.length
  if (arrLength === 0) {
    return null
  }
  return arr[arrLength - 1]
}

/**
 * // entry [ 3, 11 , 32]
 * // returns [ [ 3 ], [ 3, 11], [ 3, 11, 32 ] ]
 * @param arr
 */
export const expandArrPath = (arr) => {
  let expanded = []
  for (let i = 0; i < arr.length; i++) {
    let expandedItem = []
    for (let j = 0; j < i + 1; j++) {
      expandedItem.push(arr[j])
    }
    expanded.push(expandedItem)
  }
  return expanded
}